import React, { useState } from "react";
import Item from "./Item";
import { useTranslation } from "react-i18next";

function Billitems(props) {
  const { orders } = props;
  const { t } = useTranslation();
  const [showPopup, setShowPopup] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const getStatus = (order) => {
    const status = order.status;
    const customer = !order?.district_manager ? order.customer : "";
    const district_manager = order?.district_manager
      ? order.district_manager
      : "";
    const today = new Date();
    const deliveryDate = new Date(order.delivery_date);
    let pending = t("pending-invoice");
    let labelOne = t("pending-invoice");

    if (status == "1" && customer != "") {
      labelOne = t("pending_your_final_review");
    }
    if (customer?.district_manager) {
      pending =
        status == "2" || status == "6" || status == "1"
          ? t("pending-district-manager-approval")
          : t("pending-district-manager-approval");
      labelOne = pending;
    }
    if (
      district_manager != "" &&
      (status == "2" || status == "6" || status == "1")
    ) {
      pending = t("pending-district-manager-approval");
      labelOne = pending;
    }

    let labelDelivered = t("pending_invoice_blossoms");
    if (status == "4" && order?.invoice) {
      labelDelivered = t("pending_delivery");
      if (today > deliveryDate) {
        labelDelivered = t("delivered");
      }
    }
    var statuses = {
      1: labelOne,
      2: pending,
      3: t("rejected-order"),
      4: labelDelivered,
      6: pending,
      7: t("pending-invoice"),
      8: labelDelivered,
      9: t("rejected-by-district-manager"),
      default: t("unknown-order-status"),
    };
    return statuses[status] || statuses["default"];
  };

  const getStatusClass = (order) => {
    const status = order.status;
    const customer = !order?.district_manager ? order.customer : "";
    let pending = "warning";
    if (customer != "") {
      pending =
        status == "2" || status == "6" || status == "1" ? "warning" : "danger";
    }
    let deliveryStatus = "outstanding";

    var statuses = {
      1: "warning",
      2: pending,
      3: "danger",
      4: deliveryStatus,
      6: pending,
      7: "danger",
      8: deliveryStatus,
      9: "danger",
      default: "danger",
    };
    return statuses[status] || statuses["default"];
  };

  const handleReasonClick = (item) => {
    setSelectedReason(item.reason);
    setShowPopup(true);
  };

  const handleClose = () => {
    setShowPopup(false);
  };

  return (
    <div className="heightscr- customscroll-">
      <div className="billitem_main">
        {orders &&
          orders.length > 0 &&
          orders.map((item, index) => (
            <Item
              key={index}
              getStatus={getStatus}
              getStatusClass={getStatusClass}
              submitOrder={props.submitOrder}
              deleteOrder={props.deleteOrder}
              editOrder={props.editOrder}
              reasonpopup={handleReasonClick}
              {...item}
            />
          ))}
      </div>
      {showPopup && (
        <div className="darkpopup active notification-popup">
          <div className="darkpopup_inner">
          <div className="text" style={{ fontWeight: 'bold' }}>
              {t("rejected-note")}
            </div>
            <div className="text">
              {selectedReason || "No reason Provided"}
            </div>
            <div className="yesnobtn">
              <button
                className="whitebtn cancelbtn"
                onClick={handleClose}
              > {t('close')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Billitems;
